module.exports = __webpack_public_path__ + "img/account_bg.ad07c2d9.png";